import { createFileRoute, Outlet } from '@tanstack/react-router'
import { supplierRefundQueryOptions } from '../../../../features/purchasing/refund-queries'

export const Route = createFileRoute('/_app/supplier-refunds/$refundId')({
  staticData: { crumb: 'supplierRefund' },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(supplierRefundQueryOptions(params.refundId)),
  component: Outlet,
})
